import { ReactNode, useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastProvider } from '@/contexts/ToastContext';
import { ModalStackProvider } from '@/contexts/ModalStackContext';
import {
  ErrorBoundary,
  QueryErrorBoundary,
} from '@/components/ui/ErrorBoundary';
import { createQueryClient } from '@/utils/query-client-config';
import { ThemeProvider } from '@/contexts/ThemeContext';

interface PortalProvidersProps {
  children: ReactNode;
}

/**
 * Provider wrapper for Investor Portal
 *
 * Note: Does NOT include AuthProvider - portal uses its own simpler auth
 * system via usePortalAuth hook and localStorage tokens
 *
 * Session expiry (401 responses) is handled directly in the API client
 */
export const PortalProviders = ({ children }: PortalProvidersProps) => {
  const [queryClient] = useState(() => createQueryClient());
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <ModalStackProvider>
              <QueryErrorBoundary>{children}</QueryErrorBoundary>
            </ModalStackProvider>
          </ToastProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};
